const RED_ACTIVITY_STATUS = 4;
const YELLOW_ACTIVITY_STATUS = 3;
const GREEN_ACTIVITY_STATUS = 2;
const CLIENT_CHARGED_SERVICE_TYPE = 1;

const ActivitiesRules = {
  /**
   * Retrieves a list of activity items from the grouped quotation items.
   * @param {object} groupedQuotationItems - The grouped quotation items by activity hash table.
   * @returns {array} - The list of activity items.
   */
  getActivitiesFromGroupedQuotationItems(groupedQuotationItems) {
    return Object.keys(groupedQuotationItems).map((key) => groupedQuotationItems[key][0]);
  },

  /**
   * Retrieves the list of red activities from an activities list.
   * @param {array} activitiesList - The list of activities.
   * @returns {array} - The list of red activities.
   */
  getRedActivities(activitiesList, ordersRed) {
    const filteredItemsWithoNoBudget = ordersRed.filter(
      (redItem) => !activitiesList.some(
        (activityListItem) => activityListItem.order_activity_id === redItem.order_activity_id,
      ),
    );
    const mergedRedList = [...activitiesList, ...filteredItemsWithoNoBudget];
    return mergedRedList.filter((activity) => activity.activity_status_id === RED_ACTIVITY_STATUS);
  },

  /**
   * Retrieves the list of yellow activities from an activities list.
   * @param {array} activitiesList - The list of activities.
   * @returns {array} - The list of yellow activities.
   */
  getYellowActivities(activitiesList, ordersYellow) {
    const filteredItemsWithoNoBudget = ordersYellow.filter(
      (yellowItem) => !activitiesList.some(
        (activityListItem) => activityListItem.order_activity_id === yellowItem.order_activity_id,
      ),
    );
    const mergedYellowList = [...activitiesList, ...filteredItemsWithoNoBudget];
    return mergedYellowList.filter(
      (activity) => activity.activity_status_id === YELLOW_ACTIVITY_STATUS,
    );
  },

  /**
   * Retrieves the list of green activities from an activities list.
   * @param {array} activitiesList - The list of activities.
   * @returns {array} - The list of green activities.
   */
  greenActivities(ordersGreen) {
    return ordersGreen.filter(
      (activity) => activity.activity_status_id === GREEN_ACTIVITY_STATUS
        && activity.inventario === 0,
    );
  },

  /**
   * Retrieves the additional orders activities.
   * @param {array} additionalOrders - The additional orders.
   * @returns {array} - The list of activities.
   */
  getAdditionalOrdersActivities: (additionalOrders) => {
    const activities = [];

    additionalOrders.forEach(
      (order) => {
        order.activityClient.forEach(
          (activity) => activities.push(activity),
        );
      },
    );

    return activities;
  },

  /**
   * Retrieves a list of client charged activities from an activities list.
   * @param {Array} activitiesList - The list of activities.
   * @returns {Array} - The list of client charged activities.
   */
  getClientChargedActivities: (activitiesList) => activitiesList.filter(
    (activity) => activity.activity_service_type === CLIENT_CHARGED_SERVICE_TYPE,
  ),

  /**
   * Retrieves a list of rejected activities from an activities list.
   * @param {Array} activities - The list of activities.
   * @returns {Array} - The list of rejected activities.
   */
  getRejectedActivities: (activities) => activities.filter(
    (activity) => activity.accepted === false,
  ),
};

export default ActivitiesRules;
